<app-base-modal
  [title]="'Отвязать блогера от группы'"
>
  @if(isLoading) {
    <app-loader/>
  }
  <div class="container">
    @if (bloggerGroups.length) {
      <mat-form-field
        appearance="outline"
        class="form-field"
      >
        <mat-label>Название группы</mat-label>
        <mat-select [(ngModel)]="selectedGroup">
          @for (option of bloggerGroups; track $index) {
            <mat-option [value]="option.id">
              {{ option.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else {
      <div class="no-group">
        Блогер не привязан к группе
      </div>
    }
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="!this.selectedGroup"
      (click)="handleDetach()"
    >
      Отвязать
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отменить
    </button>
  </div>
</app-base-modal>
